<template>
  <div class="contentbox">
    <div class="homePage" v-show="!searchFlag" ref="homePage">
      <!-- <van-sticky> -->
      <div class="homePage_top">
        <div
          class="searchBox"
          v-if="
            $padFalg == 'other' &&
            (($store.state.loginStatus === 1 && $store.state.wxProgram) ||
              !$store.state.wxProgram)
          "
        >
          <div
            class="homePage_search"
            v-if="!$store.state.wxProgram"
            @click="searchClick(true)"
          ></div>
          <div
            class="xcx_search"
            v-if="$store.state.loginStatus == 1 && $store.state.wxProgram"
            @click="searchClick(true)"
          >
            <div class="homePage_search"></div>
            <span class="search_text">搜索社区内容</span>
          </div>
          <!-- <P
            v-if="
              $store.state.gameType == '3' &&
              $store.state.integralFlag &&
              !$store.state.wxProgram
            "
            class="searchBox_taskicon"
            :class="signToday == 1 ? 'searchBox_taskiconhave' : ''"
            @click="goTask()"
          ></P> -->
          <van-icon
            name="close"
            v-show="
              this.$store.state.system == 'android' &&
              applets != 'xcx' &&
              !$store.state.isXcx &&
              this.$store.state.isInGame
            "
            @click="closeCommunity"
          />
        </div>
      </div>
      <!-- </van-sticky> -->
      <!-- 首页轮播 -->
      <div
        :class="`lbwrap ${
          $store.state.loginStatus == 1 ? 'lbwrap_logined' : ''
        }`"
        v-if="allData.banners.length != 0"
      >
        <van-swipe
          class="my-swipe all_lb"
          :autoplay="lbwrapSwipeAutoplay"
          ref="lbwrapSwipe"
        >
          <van-swipe-item
            v-for="item in allData.banners"
            :key="item.id"
            @click="detailClick(item.id)"
          >
            <img :src="item.thumbnail" alt="" />
            <!-- <div class="con">
              <p>{{ item.title }}</p>
              <span>{{ item.memberNickName }} · {{ item.createTime }}</span>
            </div> -->
            <div class="bot"></div>
          </van-swipe-item>

          <!-- <van-swipe-item>
            <img src="@/assets/img/homePage/lb.jpg" alt="">
            <div class="con">
              <p>龙之国物语</p>
              <span>情报妹：2天前</span>
            </div>
            <div class="bot"></div>
          </van-swipe-item> -->
        </van-swipe>
        <div
          class="swiper-prev"
          @click="swipePrev"
          v-if="!$store.state.isMobile && allData.banners.length != 1"
        ></div>
        <div
          class="swiper-next"
          @click="swipeNext"
          v-if="!$store.state.isMobile && allData.banners.length != 1"
        ></div>
      </div>
      <!-- 金刚位 -->
      <div
        class="nav_con"
        v-if="navListArr[$store.state.gameType - 1].length != 0"
      >
        <div
          @click="goNav(item)"
          class="nav_btn"
          v-for="(item, index) in navListArr[$store.state.gameType - 1]"
          :key="index"
        >
          <div
            :class="`icon ${
              $store.state.gameType == 3 && signToday == 1 && index == 0
                ? 'sign_ed'
                : ''
            }`"
          >
            <i
              class="sign_point"
              v-if="$store.state.gameType == 3 && signToday == 0 && index == 0"
            ></i>
            <img :src="item.img" alt="" />
          </div>
          <span>{{
            $store.state.gameType == 3 && index == 0
              ? signToday == 0
                ? '每日签到'
                : '已签到'
              : item.text
          }}</span>
        </div>
      </div>
      <div
        :class="`topBar ${isFix ? 'topBar_fix' : ''} ${
          $store.state.loginStatus == 1 ? 'topBar_fix_logined' : ''
        }`"
        ref="topBar"
      >
        <van-tabs
          v-model="activeName"
          @click="tabClick"
          @change="tabChange"
          swipeable
        >
          <van-tab
            v-for="item in barList"
            :key="item.partitionName"
            :title="item.partitionName"
          >
          </van-tab>
        </van-tabs>
      </div>
      <attention
        v-if="idxon == 0"
        :topicsList="topicsList"
        :typeName="typeName"
        @tabClick="tabClick"
      ></attention>
      <all
        :style="isFix ? 'padding-top:1rem !important' : ''"
        v-if="idxon == 1"
        ref="all"
        :allData="allData"
        :typeName="typeName"
        @tabClick="tabClick"
        @init="init"
      ></all>
      <other
        :style="isFix ? 'padding-top:1rem !important' : ''"
        v-if="idxon !== 0 && idxon !== 1"
        :topicsList="topicsList"
        :tops="tops"
        :typeName="typeName"
        @tabClick="tabClick"
      ></other>
    </div>
    <sideRight ref="sideRight" v-if="$padFalg != 'other'"></sideRight>
    <search v-if="searchFlag" @searchClick="searchClick"></search>
  </div>
</template>

<script>
import Vue from 'vue';
import search from './page/search.vue';
import get from '@/api/get';
import getDateDiff from '@/assets/js/time';
import getTime from '@/utils/time';
import _ from 'lodash';
import qs from 'qs';
import { Tab, Tabs, Toast } from 'vant';
Vue.use(Tab);
Vue.use(Tabs);
import attention from './page/attention';
import all from './page/all';
import official from './page/official';
import elite from './page/elite';
import other from './page/other';
import user from '../../utils/questionConfig';
import sideRight from '../sideRight';
import { debounce } from 'lodash';
import arrNewSet from '@/utils/arrNewSet';
export default {
  name: 'homePage',
  components: { attention, all, official, elite, search, other, sideRight },
  data() {
    return {
      navListArr: [
        [],
        [
          {
            type: 1, //1内链 2外链 3签到
            text: '涂装库',
            img: require('../../assets/img/gl/painting_icon.png'),
            link: '/guidePage/painting'
          },
          {
            type: 1,
            text: '攻略站',
            img: require('../../assets/img/gl/intro_icon.png'),
            link: '/guidePage/gameintro'
          },
          {
            type: 1,
            text: 'Wiki站',
            img: require('../../assets/img/gl/wiki_icon.png'),
            link: '/guidePage/gameinfo'
          }
        ],
        [
          {
            type: 3, //1内链 2外链 3签到
            text: '每日签到',
            img: require('../../assets/img/dqss/sign1_icon.png'),
            link: ''
          },
          {
            type: 1,
            text: '兑换',
            img: require('../../assets/img/dqss/exchange_icon1.png'),
            link: '/exchangeCenter?type=needLoad'
          },
          {
            type: 1,
            text: '挑战者联赛',
            img: require('../../assets/img/dqss/competition_icon.png'),
            link: '/topicPage/?topicId=608449'
          },
          {
            type: 1,
            text: '旅者的探查',
            img: require('../../assets/img/dqss/check_icon.png'),
            link: '/guidePage/dqssgameintro?title=角色养成'
          }
        ],
        []
      ],
      isFix: false, //吸顶
      applets: window.user.weixcode ? 'xcx' : '',
      signToday: 0, //当天对否已签到
      lbwrapSwipeAutoplay: 3000,
      searchFlag: false,
      nick_name: '',
      memberNickName: '',
      activeName: 0,
      queryType: {
        id: 0, //分区类型
        // subjectId: '',
        queryType: 3, //查询类型
        sortType: 0
      },
      onLoadFlag: false,
      barList: [
        { partitionName: '关注', id: '4' },
        { partitionName: '发现', id: '0' }
        // { partitionName: '官方', id: '2' },//id为分区类型
        // { partitionName: '精华', id: '1' }
      ],
      navSubList: [],
      idxon: 1,
      allData: {
        //发现分区数据
        hotSubList: [],
        banners: [],
        tops: [],
        topicsList: []
      },
      tops: [], //帖子分区置顶
      topicsList: [], //别的分区帖子数据
      pageNo: 1,
      pageSize: 10,
      typeName: '',
      // userInfo: {},
      numBs: ''
    };
  },
  async mounted() {
    if (this.$store.state.token == '') {
      const promise = new Promise((resolve) => {
        this.resolveHander = resolve;
      });
      await promise;
    }
    this.init();
    if (this.$store.state.loginStatus == 1) {
      this.getreward(); //获取用户进入是否已签到
    }
    this.tabClick(1, '发现');
    this.activeName = 1;
    window.addEventListener(
      'scroll',
      () => {
        if (this.$route.name == 'homePage') {
          if (this.$store.state.isMobile) {
            if (this.$store.state.wxProgram) {
              //小程序内距离有变化
              if (this.$store.state.loginStatus == 0) {
                //小程序登录和未登录顶部有变化
                if (this.$refs.topBar.getBoundingClientRect().top <= 10) {
                  //topBar距离窗口顶部距离
                  this.isFix = true;
                }
                if (this.isFix == true) {
                  //吸顶时才检测
                  if (this.idxon != 0) {
                    if (
                      $('.offical_trends')[0].getBoundingClientRect().top > 45
                    ) {
                      //置顶框距离窗口顶部距离
                      this.isFix = false;
                    }
                  } else {
                    if ($('.attention')[0].getBoundingClientRect().top > 45) {
                      //置顶框距离窗口顶部距离
                      this.isFix = false;
                    }
                  }
                }
              } else {
                if (this.$refs.topBar.getBoundingClientRect().top <= 54) {
                  //topBar距离窗口顶部距离
                  this.isFix = true;
                }
                if (this.isFix == true) {
                  //吸顶时才检测
                  if (this.idxon != 0) {
                    if (
                      $('.offical_trends')[0].getBoundingClientRect().top > 86
                    ) {
                      //置顶框距离窗口顶部距离
                      this.isFix = false;
                    }
                  } else {
                    if ($('.attention')[0].getBoundingClientRect().top > 86) {
                      //置顶框距离窗口顶部距离
                      this.isFix = false;
                    }
                  }
                }
              }
            } else {
              if (this.$refs.topBar.getBoundingClientRect().top <= 80) {
                //topBar距离窗口顶部距离
                this.isFix = true;
              }
              if (this.isFix == true) {
                //吸顶时才检测
                if (this.idxon != 0) {
                  //关注下无offical_trends元素，报错
                  if (
                    $('.offical_trends')[0].getBoundingClientRect().top > 128
                  ) {
                    // alert($('.offical_trends')[0].getBoundingClientRect().top);
                    //置顶框距离窗口顶部距离
                    this.isFix = false;
                  }
                } else {
                  if ($('.attention')[0].getBoundingClientRect().top > 128) {
                    //置顶框距离窗口顶部距离
                    this.isFix = false;
                  }
                }
              }
            }
          } else {
            if (this.$refs.topBar.getBoundingClientRect().top <= 44) {
              //topBar距离窗口顶部距离
              this.isFix = true;
            }
            if (this.isFix == true) {
              //吸顶时才检测
              if (this.idxon != 0) {
                if ($('.offical_trends')[0].getBoundingClientRect().top > 110) {
                  //置顶框距离窗口顶部距离
                  this.isFix = false;
                }
              } else {
                if ($('.attention')[0].getBoundingClientRect().top > 110) {
                  //置顶框距离窗口顶部距离
                  this.isFix = false;
                }
              }
            }
          }
        }
      },
      true
    );
  },
  activated: function () {
    if (this.$padFalg != 'other') this.$refs.sideRight.init();
    if (this.$store.state.refresh) {
      if (this.$padFalg != 'other') this.$refs.sideRight.init();
      let obj = {
        name: '最新發布'
      };
      this.$refs.all.onSelect(obj);
      this.tabClick(1, '发现');
      this.activeName = 1;
    }
    if (this.$store.state.loginStatus == 1) {
      this.getreward(); //获取用户进入是否已签到
    }
  },
  watch: {
    '$store.state.token'(token) {
      if (token != '') {
        this.resolveHander && this.resolveHander();
      }
    },
    idxon(n, o) {
      this.numBs = n;
    },
    '$store.state.loginStatus': function () {
      if (this.$store.state.loginStatus == 1) {
        this.getreward();
      }
    }
  },
  methods: {
    swipePrev() {
      this.$refs.lbwrapSwipe.prev();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    swipeNext() {
      this.$refs.lbwrapSwipe.next();
      this.lbwrapSwipeAutoplay = 0;
      setTimeout(() => {
        this.lbwrapSwipeAutoplay = 3000;
      });
    },
    extractRouteAndParams(url) {
      // 分割 URL，获取路径和参数部分
      const parts = url.split('?');
      const route = parts[0];
      let params = {};

      // 如果存在参数，则进一步处理
      if (parts.length > 1) {
        // 分割参数字符串
        const paramString = parts[1];
        const paramPairs = paramString.split('&');

        // 遍历所有的参数对，将它们添加到 params 对象中
        paramPairs.forEach((pair) => {
          const [key, value] = pair.split('=');
          params[key] = value;
        });
      }
      return { route, params };
    },
    goNav(item) {
      switch (item.type) {
        case 1:
          let result = this.extractRouteAndParams(item.link);
          this.$router.push({
            path: result.route,
            query: result.params
          });
          break;
        case 2:
          location.href = item.link;
          break;
        case 3:
          this.$refs.all.signTo();
          break;
      }
    },
    detailClick(id) {
      this.$store.state.anchorFlag = false;
      this.$router.push({
        path: '../topicPage/?topicId=' + id + '&isGame=true'
      });
    },
    init() {
      user.date(window);
      // this.userInfo = window.user;
      // let form = {
      //   channelId: this.userInfo.channelId,
      //   roleName: this.userInfo.rolename,
      //   userId: this.userInfo.userid,
      //   roleId: this.userInfo.roleid,
      //   level: this.userInfo.rolelevel,
      //   serverId: this.userInfo.serverid,
      //   serverName: this.userInfo.servername,
      //   appKey: this.userInfo.appkey,
      //   ecid: this.userInfo.ecid,
      //   token: this.userInfo.token,
      //   isRealName: 1,
      //   avatar: "image",
      //   packageName: "",
      // };
      // if (form.serverId) {
      this.idxon = 0;
      this.navSubList = JSON.parse(
        JSON.stringify(this.$store.state.navSubList)
      );
      if (this.barList.length <= 2) {
        //防止下拉刷新重复添加
        this.barList = this.barList.concat(this.navSubList);
        this.barList = this.barList.slice(0, 4 - 0 + this.navSubList.length);
      }
      get.getBanner().then((res) => {
        let _data = res.data.data;
        // _data.banners.forEach((v, i) => {
        //   v.createTime = getDateDiff(v.createTime);
        // });
        // _data.tops.forEach((v, i) => {
        //   v.createTime = getDateDiff(v.createTime);
        // });
        getTime(_data.banners);
        getTime(_data.tops);
        this.allData.banners = _data.banners;
        this.allData.tops = _data.tops;
      });
      // 热门话题
      // let _topic = {
      //   type: 2,
      //   pageNo: 1,
      //   pageSize: 10
      // };
      // get.subjectList(_topic).then((res) => {
      //   let data = res.data;
      //   if (data.code == 0) {
      //     this.allData.hotSubList = data.data;
      //   } else {
      //     this.errorMessage(data);
      //   }
      // });
      // }
      if (this.$store.state.token != '') {
        // this.tabClick(0, "关注");
        this.idxon = 1;
      }
    },
    getreward() {
      get.reward().then((res) => {
        if (res.data.code == 0) {
          this.signToday = res.data.data.signToday;
        }
      });
    },
    searchClick(falg) {
      // if (this.$store.state.loginStatus !== 1) return
      this.$router.push({ name: 'search', query: {} });
      // this.searchFlag = falg;
    },
    goTask() {
      if (this.$store.state.loginStatus == 0) {
        this.$store.commit('changeLoginShow', true);
        return;
      }
      this.$router.push('/task');
    },
    tabChange() {
      this.pageNo = 1;
      if (this.isFix) {
        this.$nextTick(() => {
          var div1Height = $('.topBar').outerHeight();
          // 计算页面应该滚动的距离以使 div2 位于 div1 下方
          var scrollDistance;
          let distance = this.$store.state.wxProgram
            ? 32
            : this.$store.state.isMobile
            ? -30
            : 20;
          if (this.idxon == 1) {
            //pc 20 xcx32
            scrollDistance =
              $('.all_page').offset().top - div1Height + distance;
          } else {
            scrollDistance =
              $('.other_page').offset().top - div1Height + distance;
          }
          // 滚动页面
          $('html, body').animate(
            {
              scrollTop: scrollDistance
            },
            10
          ); // 滚动动画持续时间为1000毫秒
        });
      }
    },
    tabClick: debounce(
      function (idx, name, listload, cb, refreshFlag) {
        this.idxon = idx; //切换组件
        this.typeName = name;
        this.getId(name);
        // if (listload) {
        //   if (listload.pageNo == 1) {
        //     $('body,html').animate({ scrollTop: 0 }, 0);
        //   }
        // } else {
        //   if (this.pageNo == 1) {
        //     $('body,html').animate({ scrollTop: 0 }, 0);
        //   }
        // }
        // 获取帖子列表
        let topicInfo = {};
        refreshFlag || this.$store.state.refresh
          ? ((this.pageNo = 1), (this.topicsList = []))
          : '';
        if (listload) {
          this.queryType.sortType = listload.sortType;
          // this.onLoadFlag = listload.onLoadFlag;
          if (listload.refresh) {
            this.topicsList = [];
            this.pageNo = 1;
            topicInfo = {
              partitionId: this.queryType.id,
              queryType: this.queryType.queryType,
              // subjectId: this.queryType.subjectId,
              sortType: listload.sortType || 0,
              pageNo: listload.pageNo,
              pageSize: this.pageSize
            };
          } else {
            topicInfo = {
              partitionId: this.queryType.id,
              queryType: this.queryType.queryType,
              // subjectId: this.queryType.subjectId,
              sortType: listload.sortType || 0,
              pageNo: listload.pageNo,
              pageSize: this.pageSize
            };
          }
        } else {
          this.topicsList = [];
          this.pageNo = 1;
          topicInfo = {
            partitionId: this.queryType.id,
            queryType: this.queryType.queryType,
            // subjectId: this.queryType.subjectId,
            sortType: this.queryType.sortType || 0,
            pageNo: this.pageNo,
            pageSize: this.pageSize
          };
        }
        if (this.$store.state.token != '') {
          if (name != '发现') {
            //独立接口
            if (name == '官方') {
              //更换查询类型为官方类型
              topicInfo.queryType = 2;
            }
            if (name == '关注') {
              //更换查询类型为官方类型
              topicInfo.queryType = 4;
            }
            get.getTopics(topicInfo).then((res) => {
              console.log(res);
              var _data = res.data.data.list;
              if (topicInfo.pageNo == 1) {
                //第一页才会有置顶
                if (res.data.data?.tops) {
                  this.tops = res.data.data.tops;
                } else {
                  this.tops = [];
                  // if (name == '官方') {
                  //   //官方帖子置顶，直接将发现下的置顶帖子移动过来
                  //   this.tops = this.allData.tops;
                  // }
                }
              }
              this.topicsList = this.topicsList.concat(_data);
              this.topicsList = arrNewSet(this.topicsList);
              getTime(this.topicsList);
              this.allData.topicsList = this.topicsList;
              if (name == '发现' || name == '关注' || name == '官方') {
                this.topicsList.forEach((n, i) => {
                  n.partitionShow = true;
                });
              }
              if (!this.topicsList.length) {
                this.idxon !== 0 ? Toast('暂无内容') : '';
              }
              // if (!this.topicsList.length) {
              //   Toast("暂无内容");
              // }
              cb && cb(_data);
              this.pageNo > 1
                ? _data.length < 10
                  ? this.pageNo--
                  : this.pageNo++
                : 1;
              if (this.$store.state.refresh) {
                this.$refs.all.gopositioning();
                this.$store.commit('changeRefresh', false);
              }
            });
          } else {
            let params = {
              page: listload?.pageNo || 1,
              limit: 10,
              sortType: this.queryType.sortType
            };
            get.getTopicRecommend(params).then((res) => {
              var _data = res.data.data.list;
              this.topicsList = this.topicsList.concat(_data);
              this.topicsList = arrNewSet(this.topicsList);
              getTime(this.topicsList);
              this.allData.topicsList = this.topicsList;
              if (name == '发现' || name == '关注' || name == '官方') {
                this.topicsList.forEach((n, i) => {
                  n.partitionShow = true;
                });
              }
              if (!this.topicsList.length) {
                this.idxon !== 0 ? Toast('暂无内容') : '';
              }
              // if (!this.topicsList.length) {
              //   Toast("暂无内容");
              // }
              cb && cb(_data);
              this.pageNo > 1
                ? _data.length < 10
                  ? this.pageNo--
                  : this.pageNo++
                : 1;
              if (this.$store.state.refresh) {
                this.$refs.all.gopositioning();
                this.$store.commit('changeRefresh', false);
              }
            });
          }
        }
      },
      500,
      {
        leading: true,
        trailing: false
      }
    ),
    getId(name) {
      for (var n in this.barList) {
        if (name == this.barList[n].partitionName) {
          this.queryType.id = this.barList[n].id || 2;
          // this.queryType.subjectId = this.barList[n].id;
        }
      }
    },
    // card_common删除帖子
    removeCardCommon() {
      let _this = this;
    },
    closeCommunity() {
      window.pd.onBBSClose();
    },

    errorMessage(data) {
      let code = data.code;
      if (code != 2050) {
        let voteErr = _code.code.vote;
        let msg = voteErr[code] ? voteErr[code] : voteErr['other'] + code;
        Toast(msg);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.lbwrap {
  margin-top: 1.6rem;
}
.nav_con {
  width: 6.88rem;
  border-radius: 0.1rem;
  margin: 0 auto;
  margin-top: 0.2rem;
  margin-bottom: 0.2rem;
  // border-radius: 0.2rem;
  padding: 0.2rem 0.4rem;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  overflow-x: auto;
  .nav_btn {
    width: 1.2rem;
    height: 1.2rem;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    .icon {
      width: 0.8rem;
      height: 0.8rem;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .sign_point {
        width: 0.16rem;
        height: 0.16rem;
        background-color: red;
        position: absolute;
        top: 0rem;
        right: -0.1rem;
        border-radius: 50%;
      }
    }
    .sign_ed {
      -webkit-filter: grayscale(100%);
      -moz-filter: grayscale(100%);
      -o-filter: grayscale(100%);
      filter: grayscale(100%);
    }
    span {
      /* 禁止选择文本 */
      user-select: none;
      font-size: 0.22rem;
    }
  }
}
.ipad .nav_con {
  width: 100%;
}
.nav_con::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
.nav_con::-webkit-scrollbar {
  display: none; /* 隐藏滚动条 */
}
.ipad .nav_con {
  border-radius: 0.2rem;
}
.topBar_fix {
  position: fixed;
  z-index: 3;
  top: 1.5rem;
  box-shadow: 0 0.02rem 0.1rem rgba(0, 0, 0, 0.2);
}
.ipad .topBar_fix {
  width: 8.5rem;
  top: 0.52rem;
}
.xcx .topBar_fix {
  top: 0.14rem;
}
.xcx .topBar_fix_logined {
  top: 1.1rem !important;
}
</style>
